import React from "react";
import { Input, Button, Alert, Row, Col, Form } from "antd";
import { SafetyOutlined, LockOutlined } from "@ant-design/icons";

export const AutorizacionSupervisor = ({
  claveSupervisor,
  setClaveSupervisor,
  onAutorizar,
  loading,
  requiereAutorizacion,
}) => {
  if (!requiereAutorizacion) return null;

  return (
    <>
      <Alert
        message="Autorización requerida"
        description="El asegurado tiene servicios previos, se requiere clave de supervisor para continuar."
        type="warning"
        showIcon
        className="crear-servicios-v2__alert"
      />

      <Form layout="vertical" size="large">
        <Row gutter={12}>
          <Col xs={24} sm={16}>
            <Form.Item label="Clave de Supervisor">
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Ingrese código de supervisor"
                value={claveSupervisor}
                onChange={(event) => setClaveSupervisor(event.target.value)}
                visibilityToggle={false}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label={<span>&nbsp;</span>} colon={false}>
              <Button
                type="primary"
                icon={<SafetyOutlined />}
                onClick={onAutorizar}
                loading={loading}
                disabled={!claveSupervisor}
                block
                size="large"
              >
                Autorizar y Continuar
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};
